import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useRef } from 'react';
import { Field, Form } from 'react-final-form';
import classNames from 'classnames/bind';
import Scrollbar from "../../../../Scrollbar";
import Search from "../../../../Search";
import { defaultPropArray } from "../../../../constants";
import { getMethodsForTestId } from "../../../../utils/getMethodsForTestId";
import noop from "../../../../utils/noop";
import { SearchLoader } from '../SearchLoader';
import { SearchNotFound } from '../SearchNotFound';
import { SearchResults } from '../SearchResults';
import { SearchSubMenuItems } from '../SearchSubMenuItems';
import styles from './HeaderSearch.css';
var cx = classNames.bind(styles);
export var HeaderSearch = function HeaderSearch(_ref) {
  var results = _ref.results,
      _onSubmit = _ref.onSubmit,
      mobile = _ref.mobile,
      placeholder = _ref.placeholder,
      namespace = _ref.namespace,
      value = _ref.value,
      onChange = _ref.onChange,
      loading = _ref.loading,
      notFound = _ref.notFound,
      notFoundTitle = _ref.notFoundTitle,
      notFoundSubtitle = _ref.notFoundSubtitle,
      _ref$navigationResult = _ref.navigationResult,
      navigationResult = _ref$navigationResult === void 0 ? defaultPropArray : _ref$navigationResult,
      theme = _ref.theme,
      tablet = _ref.tablet,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? noop : _ref$onClose;
  var inputRef = useRef(null);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'search'),
      getTestId = _getMethodsForTestId.getTestId;

  useEffect(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root')
  }, getTestId()), /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(values) {
      return _onSubmit(values.search);
    },
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit;
      return /*#__PURE__*/React.createElement("form", {
        className: cx('form', {
          mobile: mobile
        }, {
          tablet: tablet
        }),
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement(Field, {
        name: "search"
      }, function (_ref3) {
        var input = _ref3.input;
        return /*#__PURE__*/React.createElement(Search, _extends({}, input, {
          inputProps: {
            ref: inputRef
          },
          placeholder: placeholder,
          theme: "grey",
          size: "small",
          clearable: true,
          value: value,
          onChange: onChange
        }));
      }));
    }
  }), value && /*#__PURE__*/React.createElement("div", {
    className: cx('popover')
  }, /*#__PURE__*/React.createElement(Scrollbar, {
    classes: {
      root: cx('popover_inner')
    }
  }, navigationResult.map(function (item) {
    return /*#__PURE__*/React.createElement(SearchSubMenuItems, {
      key: item.title,
      searchValue: value,
      group: item,
      theme: theme,
      onClose: onClose
    });
  }), Boolean(navigationResult.length) && /*#__PURE__*/React.createElement("div", {
    className: cx('divider')
  }), results && /*#__PURE__*/React.createElement(SearchResults, {
    hideFirstDivider: navigationResult.length === 0,
    items: results,
    searchValue: value
  }), loading && /*#__PURE__*/React.createElement(SearchLoader, null), notFound && /*#__PURE__*/React.createElement(SearchNotFound, {
    title: notFoundTitle,
    subtitle: notFoundSubtitle
  }))));
};